import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "account-rule-setting"
};
const _hoisted_2 = {
  class: "supplier"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 返回 ");

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "选择分账团队", -1);

const _hoisted_5 = {
  class: "setting"
};
const _hoisted_6 = {
  class: "header",
  style: {
    "display": "none"
  }
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "参与分账的订单", -1);

const _hoisted_8 = {
  class: "checkbox-group"
};
const _hoisted_9 = {
  class: "main-checkbox"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 开票订单 ");

const _hoisted_11 = {
  class: "sub-checkboxes"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-left"
}, "(", -1);

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 订单金额结算订单 ");

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 预付金额结算订单 ");

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-right"
}, ")", -1);

const _hoisted_16 = {
  class: "checkbox-group"
};
const _hoisted_17 = {
  class: "main-checkbox"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 非开票订单 ");

const _hoisted_19 = {
  class: "sub-checkboxes"
};

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-left"
}, "(", -1);

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 订单金额结算订单 ");

const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 预付金额结算订单 ");

const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "bracket-right"
}, ")", -1);

const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "参与分账的商品"), /*#__PURE__*/_createElementVNode("span", {
  class: "info"
}, "订单中商品按照销售金额比例或固定金额进行分账")], -1);

const _hoisted_25 = {
  class: "table-toolbox"
};
const _hoisted_26 = {
  class: "left"
};

const _hoisted_27 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_28 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_29 = /*#__PURE__*/_createTextVNode("不参与人员管理");

const _hoisted_30 = {
  class: "right"
};
const _hoisted_31 = {
  class: "wrapper"
};

const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商品名称", -1);

const _hoisted_33 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_34 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_35 = ["innerHTML"];
const _hoisted_36 = ["innerHTML"];
const _hoisted_37 = ["innerHTML"];

const _hoisted_38 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "请先前往"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "控销团队-业务管理"), /*#__PURE__*/_createElementVNode("span", null, "处进行"), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "分账受益人设置/确认"), /*#__PURE__*/_createElementVNode("span", null, "，已确保分账正确")], -1);

const _hoisted_40 = /*#__PURE__*/_createTextVNode("我已设置/确认");

const _hoisted_41 = /*#__PURE__*/_createTextVNode("去设置/确认");

import { ref, reactive, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
import SettingUpdateModal from './components/setting-update-modal';
import NojoinModal from './components/nojoin-modal';
export default {
  name: 'setting',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    onMounted(() => getSupplierList());
    const search = reactive({
      supplierId: parseInt(route.query.supplierId) || '',
      prodName: ''
    });
    const supplierList = ref([]);
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '商品名称',
        field: 'prodName',
        width: 160
      }, {
        title: '分账方式',
        field: 'splitMethodName',
        width: 100
      }, {
        title: '分账订单范围',
        field: 'invoiceSettmentTypeTextList',
        width: 200,
        slots: {
          default: 'invoiceSettmentTypeTextList'
        }
      }, {
        title: '一级团队分账比例',
        field: 'levelOneSplitRuleText',
        slots: {
          default: 'levelOneSplitRuleText'
        }
      }, {
        title: '二级团队分账比例',
        field: 'levelTwoSplitRuleText',
        slots: {
          default: 'levelTwoSplitRuleText'
        }
      }, {
        title: '三级团队分账比例',
        field: 'levelThreeSplitRuleText',
        slots: {
          default: 'levelThreeSplitRuleText'
        }
      }, {
        title: '操作',
        field: 'operation',
        width: 80,
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, search);

            Axios.get('/admin/split/rule/getMerchandiseSplitRuleList.json', {
              params
            }).then(res => {
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });
    const loading = ref(true);

    function getSupplierList() {
      // let params = { isFilterManufacture: 1 }
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;

        if (supplierList.value.length === 1) {
          search.supplierId = supplierList.value[0].supplierId;
          supplierChange();
        }
      }).finally(() => loading.value = false);
    }

    function supplierChange() {
      if (!route.query.supplierId) {
        setConfirmModal.value = true;
      }

      reset();
    }

    function reset() {
      search.prodName = '';
      table.value.commitProxy('reload');
    }

    function deleteHandle() {
      let list = table.value.getCheckboxRecords();

      if (list.length === 0) {
        ElMessage.error('请选择数据删除');
        return;
      }

      ElMessageBox.confirm('确认删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        let merchandiseRelationIds = list.map(v => v.merchandiseRelationId).join();
        let url = `/admin/split/rule/deleteMerchandiseSplitRule.json?merchandiseRelationIds=${merchandiseRelationIds}`;
        Axios.post(url).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    const setConfirmModal = ref(false);
    const settingUpdateModal = reactive({
      show: false,
      merchandiseRelationId: ''
    });
    const nojoinModal = reactive({
      show: false
    });

    function createHandle() {
      settingUpdateModal.show = true;
      settingUpdateModal.merchandiseRelationId = '';
    }

    function editHandle(data) {
      settingUpdateModal.merchandiseRelationId = data.merchandiseRelationId;
      settingUpdateModal.show = true;
    } // 开票订单设置


    const invoiceSettings = reactive({
      mainChecked: false,
      orderAmount: false,
      preAmount: false
    }); // 非开票订单设置

    const noInvoiceSettings = reactive({
      mainChecked: false,
      orderAmount: false,
      preAmount: false
    }); // 处理主选项变化

    function handleMainCheckboxChange(type) {
      const settings = type === 'invoice' ? invoiceSettings : noInvoiceSettings; // 主选项选中，子选项全选

      if (settings.mainChecked) {
        settings.orderAmount = true;
        settings.preAmount = true;
      } else {
        // 主选项取消，子选项全部取消
        settings.orderAmount = false;
        settings.preAmount = false;
      }

      saveSettings();
    } // 处理子选项变化


    function handleSubCheckboxChange(type) {
      const settings = type === 'invoice' ? invoiceSettings : noInvoiceSettings; // 根据子选项状态更新主选项

      settings.mainChecked = settings.orderAmount || settings.preAmount;
      saveSettings();
    } // 保存设置到服务器


    function saveSettings() {
      // 构建开票订单的值
      const invoiceValues = [];

      if (invoiceSettings.mainChecked) {
        if (invoiceSettings.orderAmount) invoiceValues.push('1');
        if (invoiceSettings.preAmount) invoiceValues.push('2');
      } else {
        invoiceValues.push('');
      } // 构建非开票订单的值


      const noInvoiceValues = [];

      if (noInvoiceSettings.mainChecked) {
        if (noInvoiceSettings.orderAmount) noInvoiceValues.push('1');
        if (noInvoiceSettings.preAmount) noInvoiceValues.push('2');
      } else {
        noInvoiceValues.push('');
      }

      const params = {
        supplierId: parseInt(route.query.supplierId) || search.supplierId,
        invoiceSettmentTypeValue: invoiceValues.join(','),
        noInvoiceSettmentTypeValue: noInvoiceValues.join(',')
      };

      if (!params.supplierId) {
        ElMessage.error('请先选择团队');
        invoiceSettings.mainChecked = false;
        invoiceSettings.orderAmount = false;
        invoiceSettings.preAmount = false;
        noInvoiceSettings.mainChecked = false;
        noInvoiceSettings.orderAmount = false;
        noInvoiceSettings.preAmount = false;
        return;
      }

      Axios.post('/admin/split/rule/setInvoiceSettmentType.json', params).then(res => {
        const {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('设置成功');
        } else {
          ElMessage.error(msg);
        }
      });
    } // 初始化设置


    function initSettings(data) {
      if (data.invoiceSettmentTypeValue) {
        invoiceSettings.mainChecked = true;
        invoiceSettings.orderAmount = data.invoiceSettmentTypeValue.includes('1');
        invoiceSettings.preAmount = data.invoiceSettmentTypeValue.includes('2');
      } else {
        invoiceSettings.mainChecked = false;
        invoiceSettings.orderAmount = false;
        invoiceSettings.preAmount = false;
      }

      if (data.noInvoiceSettmentTypeValue) {
        noInvoiceSettings.mainChecked = true;
        noInvoiceSettings.orderAmount = data.noInvoiceSettmentTypeValue.includes('1');
        noInvoiceSettings.preAmount = data.noInvoiceSettmentTypeValue.includes('2');
      } else {
        noInvoiceSettings.mainChecked = false;
        noInvoiceSettings.orderAmount = false;
        noInvoiceSettings.preAmount = false;
      }
    }

    function getSettings(supplierId) {
      // 获取当前设置
      Axios.get('/admin/split/rule/getInvoiceSettmentType.json', {
        params: {
          supplierId: supplierId
        }
      }).then(res => {
        if (res.data.success) {
          initSettings(res.data.data);
        }
      });
    } // 监听 supplierId 变化，重新获取设置


    watch(() => route.query.supplierId, newVal => {
      if (newVal) {
        getSettings(newVal);
      }
    }, {
      immediate: true
    });
    watch(() => search.supplierId, newVal => {
      if (newVal) {
        getSettings(newVal);
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_Back = _resolveComponent("Back");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_router_link = _resolveComponent("router-link");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        class: "back",
        to: {
          name: 'sepaccountRule'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Back)]),
          _: 1
        }), _hoisted_3]),
        _: 1
      }), _hoisted_4, _createVNode(_component_el_select, {
        disabled: _unref(route).query.supplierId,
        filterable: "",
        modelValue: search.supplierId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.supplierId = $event),
        placeholder: "请选择分账团队",
        style: {
          "width": "250px"
        },
        onChange: supplierChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["disabled", "modelValue"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_checkbox, {
        modelValue: invoiceSettings.mainChecked,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => invoiceSettings.mainChecked = $event),
        onChange: _cache[2] || (_cache[2] = $event => handleMainCheckboxChange('invoice'))
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_checkbox, {
        modelValue: invoiceSettings.orderAmount,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => invoiceSettings.orderAmount = $event),
        onChange: _cache[4] || (_cache[4] = $event => handleSubCheckboxChange('invoice'))
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: invoiceSettings.preAmount,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => invoiceSettings.preAmount = $event),
        onChange: _cache[6] || (_cache[6] = $event => handleSubCheckboxChange('invoice'))
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_15])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_checkbox, {
        modelValue: noInvoiceSettings.mainChecked,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => noInvoiceSettings.mainChecked = $event),
        onChange: _cache[8] || (_cache[8] = $event => handleMainCheckboxChange('noInvoice'))
      }, {
        default: _withCtx(() => [_hoisted_18]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_checkbox, {
        modelValue: noInvoiceSettings.orderAmount,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => noInvoiceSettings.orderAmount = $event),
        onChange: _cache[10] || (_cache[10] = $event => handleSubCheckboxChange('noInvoice'))
      }, {
        default: _withCtx(() => [_hoisted_21]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: noInvoiceSettings.preAmount,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => noInvoiceSettings.preAmount = $event),
        onChange: _cache[12] || (_cache[12] = $event => handleSubCheckboxChange('noInvoice'))
      }, {
        default: _withCtx(() => [_hoisted_22]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_23])])]), _hoisted_24, _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: createHandle,
        disabled: !search.supplierId
      }, {
        default: _withCtx(() => [_hoisted_27]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_el_button, {
        type: "danger",
        onClick: deleteHandle
      }, {
        default: _withCtx(() => [_hoisted_28]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[13] || (_cache[13] = $event => nojoinModal.show = true),
        disabled: !search.supplierId
      }, {
        default: _withCtx(() => [_hoisted_29]),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_el_input, {
        modelValue: search.prodName,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => search.prodName = $event),
        placeholder: "请输入商品名称",
        style: {
          "width": "250px"
        }
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[15] || (_cache[15] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_33]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_34]),
        _: 1
      })])]), search.supplierId ? (_openBlock(), _createBlock(_component_vxe_grid, _mergeProps({
        key: 0,
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        invoiceSettmentTypeTextList: _withCtx(({
          row
        }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.invoiceSettmentTypeTextList, invoiceSettmentTypeText => {
          return _openBlock(), _createElementBlock("div", null, _toDisplayString(invoiceSettmentTypeText), 1);
        }), 256))]),
        levelOneSplitRuleText: _withCtx(({
          row
        }) => [_createElementVNode("div", {
          innerHTML: row.levelOneSplitRuleText
        }, null, 8, _hoisted_35)]),
        levelTwoSplitRuleText: _withCtx(({
          row
        }) => [_createElementVNode("div", {
          innerHTML: row.levelTwoSplitRuleText
        }, null, 8, _hoisted_36)]),
        levelThreeSplitRuleText: _withCtx(({
          row
        }) => [_createElementVNode("div", {
          innerHTML: row.levelThreeSplitRuleText
        }, null, 8, _hoisted_37)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: $event => editHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_38]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)) : _createCommentVNode("", true)]), _createVNode(_component_el_dialog, {
        modelValue: setConfirmModal.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => setConfirmModal.value = $event),
        title: "分账受益人设置确认",
        width: "500px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = $event => setConfirmModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_40]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[17] || (_cache[17] = $event => _unref(router).push({
            name: 'BusinessManage',
            query: {
              supplierId: search.supplierId,
              storeType: 2,
              from: 'ControlSalesTeam'
            }
          }))
        }, {
          default: _withCtx(() => [_hoisted_41]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_39]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(SettingUpdateModal), {
        modelValue: settingUpdateModal.show,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => settingUpdateModal.show = $event),
        supplierId: search.supplierId,
        merchandiseRelationId: settingUpdateModal.merchandiseRelationId,
        onSuccess: _cache[20] || (_cache[20] = $event => table.value.commitProxy('reload'))
      }, null, 8, ["modelValue", "supplierId", "merchandiseRelationId"]), _createVNode(_unref(NojoinModal), {
        modelValue: nojoinModal.show,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => nojoinModal.show = $event),
        supplierId: search.supplierId
      }, null, 8, ["modelValue", "supplierId"])]);
    };
  }

};